import styled$1 from 'styled-components';
import '@ccg/core';
import '@4rk/modular-system';
import { getTypography, fontFamily } from '../../styles/typography.js';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import RevealTypography$1 from '../../components/RevealTypography/RevealTypography.js';

const StyledTypography = styled$1.p`
  margin: 0;
  padding: 0;
  font-weight: normal;
  text-transform: ${props => props.transform};
  font-feature-settings: 'liga' 1;
  ${({
  variant
}) => getTypography[variant]}

  .typography__highlight {
    ${fontFamily('accent')};
  }
`;

const Typography = ({
  as,
  children,
  className,
  isVisible,
  reveal,
  revealVariant,
  transform,
  variant
}) => /*#__PURE__*/React$1.createElement(StyledTypography, {
  as: as,
  className: className,
  transform: transform,
  variant: variant
}, reveal ? /*#__PURE__*/React$1.createElement(RevealTypography$1, {
  isVisible: isVisible,
  variant: revealVariant
}, children) : children);

Typography.propTypes = {
  as: PropTypes$1.oneOf(['p', 'div', 'span', 'cite', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  children: PropTypes$1.node.isRequired,
  className: PropTypes$1.string,
  isVisible: PropTypes$1.bool,
  reveal: PropTypes$1.bool,
  revealVariant: PropTypes$1.oneOf(['primary', 'secondary']),
  transform: PropTypes$1.oneOf(['uppercase', 'lowercase']),
  variant: PropTypes$1.oneOf(['copy', 'intro', 'small', 'headline', 'hero', 'subline', 'quote', 'quoteBig', 'subheadline', 'copyIntro', 'div'])
};
Typography.defaultProps = {
  as: 'p',
  className: '',
  isVisible: true,
  reveal: false,
  revealVariant: 'primary',
  transform: null,
  variant: 'copy'
};

export default Typography;
